import img1 from '../assets/Root/browser__SI-next-image - 01.png'
import img2 from '../assets/Root/browser__SI-next-image - 02.png'
import img3 from '../assets/Root/browser__SI-next-image - 03.png'
import img4 from '../assets/Root/browser__SI-next-image - 04.png'
import img5 from '../assets/Root/browser__SI-next-image - 05.png'
import img6 from '../assets/Root/browser__SI-next-image - 06.png'
import img8 from '../assets/Root/browser__SI-next-image - 01.png'
import img7 from '../assets/Root/browser__SI-next-image - 02.png'
import img9 from '../assets/Root/browser__SI-next-image - 03.png'
import img10 from '../assets/Root/browser__SI-next-image - 04.png'
import img11 from '../assets/Root/browser__SI-next-image - 05.png'
import img12 from '../assets/Root/browser__SI-next-image - 06.png'
import img13 from '../assets/Root/browser__SI-next-image - 01.png'
import img14 from '../assets/Root/browser__SI-next-image - 02.png'
import img15 from '../assets/Root/browser__SI-next-image - 03.png'
import img16 from '../assets/Root/browser__SI-next-image - 04.png'



export const mapRotationData = [
    {
        imgUrl: img1,
        text1:"CONQUEST LARGE",
        text2:"DAWNBREAKER"
        
    },
    {
        imgUrl: img2,
        text1:"CONQUEST LARGE",
        text2:"PROPAGANDA"
        
    },
    {
        imgUrl: img3,
        text1:"CONQUEST LARGE",
        text2:"OPEARATION LOCKER"
    },
    {
        imgUrl: img4,
        text1:"CONQUEST LARGE",
        text2:"LANCANG DAM"
    },
    {
        imgUrl: img5,
        text1:"CONQUEST LARGE",
        text2:"SIEGE OF SHANGHAI"
    },
    {
        imgUrl: img6,
        text1:"CONQUEST LARGE",
        text2:"GOLMUD RAILWAY"
    },
    {
        imgUrl: img7,
        text1:"CONQUEST LARGE",
        text2:"PROPAGANDA"
    },
    {
        imgUrl: img8,
        text1:"CONQUEST LARGE",
        text2:"SIEGE OF SHANGHAI"
    },
    {
        imgUrl: img9,
        text1:"CONQUEST LARGE",
        text2:"DAWNBREAKER"
    },
    {
        imgUrl: img10,
        text1:"CONQUEST LARGE",
        text2:"PROPAGANDA"
    },
    {
        imgUrl: img11,
        text1:"CONQUEST LARGE",
        text2:"OPERATION LOCKER"
    },
    {
        imgUrl: img12,
        text1:"CONQUEST LARGE",
        text2:"LANCHANG DAM"
    },
    {
        imgUrl: img13,
        text1:"CONQUEST LARGE",
        text2:"SIEGE OF SHANGHAI"
        
    },
    {
        imgUrl: img14,
        text1:"CONQUEST LARGE",
        text2:"GOLMUD RAILWAY"
    },
    {
        imgUrl: img15,
        text1:"CONQUEST LARGE",
        text2:"PROPAGANDA"
    },
    {
        imgUrl: img16,
        text1:"CONQUEST LARGE",
        text2:"SIEGE OF SHANGHAI"
    }
]